import styled from 'styled-components';

export const Header = styled.div`
    background: #FAFAFA;
    border: 1px solid #ADADAD;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    font-weight: 500;
    font-family: 'Poppins';
    color: #313131;
    padding: 15px;
    font-size: larger;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const UserDetails = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    justify-content: space-between;
    align-items: ${props => props.alignItems};
    padding: 10px 0px;
`;

export const Text = styled.p`
    font-weight: 500;
    font-size: 13px;
    margin-bottom: 10px;
    margin-top: 0;
`;

export const ModalBox = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80vw;
    height: 90vh;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 24;
    padding: 20px;
    overflow: auto;
`;

export const AddMealBox = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    justify-content: space-between;
    align-items: ${props => props.alignItems};
    padding: 10px 0px;
`;

export const AddMealBoxV1 = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    justify-content: space-between;
    align-items: ${props => props.alignItems};
    padding: 10px 0px;
    position : sticky;
    top : 100px;
`;

export const NutritionFoodWrap = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    justify-content: space-between;
    align-items: ${props => props.alignItems};
    padding: 10px 0px;
`;

export const BreakfastWrap = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    justify-content: space-between;
    align-items: ${props => props.alignItems};
    padding: 10px 0px;
    width : 50%;
`;

export const EnergyDistributionWrap = styled.div`
    display: flex;
    flex-direction: ${props => props.direction};
    justify-content: space-between;
    align-items: ${props => props.alignItems};
    padding: 10px 0px;
    width: 100%;
`;

